import { ActionContext } from 'vuex';

import { checkPermission } from '@/common/utils/security';
import { getLocalState } from '@/common/utils/store';

import { PERMISSION_CHECKS_MUTATIONS_NAME } from './name';
import { TPermissionChecksState } from './types';

const inFlightChecks = new Map<number, Promise<boolean>>();

export async function ensurePermissionChecked(
  context: ActionContext<TPermissionChecksState, unknown>,
  permissionId: number,
): Promise<boolean> {
  const cached = context.state.checks[permissionId];

  if (cached === true || cached === false) {
    return cached;
  }

  const inFlight = inFlightChecks.get(permissionId);

  if (inFlight) {
    return inFlight;
  }

  context.commit(getLocalState(PERMISSION_CHECKS_MUTATIONS_NAME.setPermissionCheck), {
    permissionId,
    status: 'pending',
  });

  const request = (async (): Promise<boolean> => {
    try {
      const response = await checkPermission(permissionId);
      const hasAccess = Boolean(response.data);

      context.commit(getLocalState(PERMISSION_CHECKS_MUTATIONS_NAME.setPermissionCheck), {
        permissionId,
        status: hasAccess,
      });

      return hasAccess;
    } catch {
      context.commit(getLocalState(PERMISSION_CHECKS_MUTATIONS_NAME.setPermissionCheck), {
        permissionId,
        status: false,
      });

      return false;
    } finally {
      inFlightChecks.delete(permissionId);
    }
  })();

  inFlightChecks.set(permissionId, request);

  return request;
}

export function resetPermissionChecks(context: ActionContext<TPermissionChecksState, unknown>) {
  inFlightChecks.clear();
  context.commit(getLocalState(PERMISSION_CHECKS_MUTATIONS_NAME.resetPermissionChecks));
}
